function cov_2ogcnz61y5() {
  var path = "/app/src/utils/check-theme.tsx";
  var hash = "b57afe2f6e3a2255731655e635e9471559241efd";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/app/src/utils/check-theme.tsx",
    statementMap: {
      "0": {
        start: {
          line: 5,
          column: 26
        },
        end: {
          line: 10,
          column: 1
        }
      },
      "1": {
        start: {
          line: 6,
          column: 9
        },
        end: {
          line: 6,
          column: 35
        }
      },
      "2": {
        start: {
          line: 7,
          column: 9
        },
        end: {
          line: 7,
          column: 41
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 6,
            column: 2
          },
          end: {
            line: 6,
            column: 3
          }
        },
        loc: {
          start: {
            line: 6,
            column: 9
          },
          end: {
            line: 6,
            column: 35
          }
        },
        line: 6
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 7,
            column: 2
          },
          end: {
            line: 7,
            column: 3
          }
        },
        loc: {
          start: {
            line: 7,
            column: 9
          },
          end: {
            line: 7,
            column: 41
          }
        },
        line: 7
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 7,
            column: 9
          },
          end: {
            line: 7,
            column: 41
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 7,
            column: 9
          },
          end: {
            line: 7,
            column: 23
          }
        }, {
          start: {
            line: 7,
            column: 27
          },
          end: {
            line: 7,
            column: 41
          }
        }],
        line: 7
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0
    },
    f: {
      "0": 0,
      "1": 0
    },
    b: {
      "0": [0, 0]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "b57afe2f6e3a2255731655e635e9471559241efd"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_2ogcnz61y5 = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_2ogcnz61y5();
import { CardTheme } from 'src/types/card-theme';
import { ThemeType } from 'src/types/theme-type';
import { createNormalizeChecking } from 'src/utils/create-normalize-checking';
export var checkTheme = (cov_2ogcnz61y5().s[0]++, createNormalizeChecking(function (v) {
  cov_2ogcnz61y5().f[0]++;
  cov_2ogcnz61y5().s[1]++;
  return "".concat(v).trim();
}, function (v) {
  cov_2ogcnz61y5().f[1]++;
  cov_2ogcnz61y5().s[2]++;
  return (cov_2ogcnz61y5().b[0][0]++, v in ThemeType) || (cov_2ogcnz61y5().b[0][1]++, v in CardTheme);
}, 'The theme parameter has an incorrect value. Please check it', ThemeType.default));